import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  TextField,
  Typography,
  Paper,
  InputAdornment, IconButton
} from '@mui/material';
import { toast } from 'react-toastify';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const URL = process.env.REACT_APP_API_ENDPOINT;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    document.title = 'Admin Login - Marathon Tracker';

    if (localStorage.getItem('adminAuthenticated') === 'true') {
      navigate('/dashboard/message');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      toast.error('Please enter both username and password');
      return;
    }

    setLoading(true);

    try {
      const formBody = new URLSearchParams({
        username,
        password,
      });

      const response = await fetch(
        `${URL}Register/login/access-token`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
          },
          body: formBody.toString(),
        }
      );

      const data = await response.json();

      if (response.ok && data.status === 1) {
        // Save token & user data in localStorage (or wherever you want)
        localStorage.setItem('adminAuthenticated', 'true');
        localStorage.setItem('accessToken', data.access_token);
        localStorage.setItem('userId', data.user_id);
        localStorage.setItem('userRole', data.UserRole);
        localStorage.setItem('businessName', data.BusinessName);

        toast.success(data.msg || 'Login successful');
        navigate('/dashboard/message');
      } else {
        toast.error(data.msg || 'Login failed, please check your credentials');
      }
    } catch (error) {
      toast.error('Something went wrong. Please try again later.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">

      <Container component="main" maxWidth="sm" sx={{ flexGrow: 1, py: 8 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Box textAlign="center" mb={3}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '80px', // or any height you need
                backgroundColor: '#9f1d21',

              }}
            >
              <img
                src="https://myraceindia.com/assets/logos/header-logo.png"
                alt="Logo"
                style={{
                  width: '100px',
                  height: '40px',
                  objectFit: 'contain',
                }}
              />
            </div>

            <Typography component="h1" variant="h5" fontWeight="bold">
              Admin Login
            </Typography>
            <Typography variant="body2" color="textSecondary" mt={1}>
              Enter your credentials to manage marathon events
            </Typography>
          </Box>

          <Box component="form" onSubmit={handleLogin} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleTogglePasswordVisibility}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                mt: 2,
                backgroundColor: '#9f1d21',
                '&:hover': {
                  backgroundColor: '#ff474d', // Slightly darker shade for hover effect
                },
              }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
            </Button>
          </Box>
        </Paper>
      </Container>

    </Box>
  );
};

export default AdminLogin;